// mds-dojo — dojo/errors/CancelError — FAITHFUL port. Default error when a promise
// is canceled without a reason (dojoType "cancel", not logged).
import create from './create';

export default create('CancelError', null, null, { dojoType: 'cancel', log: false });
